export interface PointerDownCoordinates {
  x: number;
  y: number;
}

export const hasNonEmptyTextSelection = (): boolean => {
  const selection = window.getSelection();
  return !!selection && !selection.isCollapsed && selection.toString().length > 0;
};

const selectionNodeInElement = (element: HTMLElement, node: Node | null): boolean => {
  if (!node) {
    return false;
  }
  const nodeElement = node.nodeType === Node.TEXT_NODE ? node.parentElement : node instanceof Element ? node : null;

  return !!nodeElement && element.contains(nodeElement);
};

export const hasTextSelectionInElement = (element: HTMLElement): boolean => {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed) {
    return false;
  }
  if (selection.toString().length > 0) {
    return (
      selectionNodeInElement(element, selection.anchorNode) ||
      selectionNodeInElement(element, selection.focusNode)
    );
  }
  return (
    selectionNodeInElement(element, selection.anchorNode) ||
    selectionNodeInElement(element, selection.focusNode)
  );
};

export const isPointerDragSelectionGesture = (down: PointerDownCoordinates | null, up: PointerDownCoordinates, thresholdPx = 4): boolean => {
  if (!down) {
    return false;
  }
  const deltaX = up.x - down.x;
  const deltaY = up.y - down.y;
  return deltaX * deltaX + deltaY * deltaY > thresholdPx * thresholdPx;
};

export const isTextSelectionRowClickIntent = (row: HTMLElement, event: MouseEvent, pointerDown: PointerDownCoordinates | null): boolean => {
  if (hasNonEmptyTextSelection() || hasTextSelectionInElement(row)) {
    return true;
  }
  return isPointerDragSelectionGesture(pointerDown, { x: event.clientX, y: event.clientY });
};
